"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseToast = exports.InfoToast = exports.ErrorToast = exports.SuccessToast = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var Icon_1 = require("../Icon");
var BaseToast = function (_a) {
    var variant = _a.variant, icon = _a.icon, iconColor = _a.iconColor, description = _a.description, onClose = _a.onClose;
    var hoverColor = "".concat(iconColor, "1A");
    return (React.createElement(react_1.Alert, { variant: variant, w: "100%" },
        React.createElement(Icon_1.Icon, { type: icon, color: iconColor, boxSize: "20px", paddingRight: "10px" }),
        React.createElement(react_1.AlertDescription, { paddingRight: "40px" }, description),
        React.createElement(react_1.Spacer, null),
        React.createElement(react_1.IconButton, { "aria-label": "Close pop-up", variant: "ghost", size: "lg", position: "absolute", right: "8px", width: "40px", height: "32px", _hover: { bg: hoverColor }, onClick: onClose },
            React.createElement(Icon_1.Icon, { type: pro_regular_svg_icons_1.faXmark }))));
};
var SuccessToast = function (_a) {
    var description = _a.description, onClose = _a.onClose;
    return (React.createElement(BaseToast, { variant: "success", icon: pro_regular_svg_icons_1.faCircleCheck, iconColor: "#1A7A42", description: description, onClose: onClose }));
};
exports.SuccessToast = SuccessToast;
var ErrorToast = function (_a) {
    var description = _a.description, onClose = _a.onClose;
    return (React.createElement(BaseToast, { variant: "error", icon: pro_regular_svg_icons_1.faCircleExclamation, iconColor: "#C01614", description: description, onClose: onClose }));
};
exports.ErrorToast = ErrorToast;
var InfoToast = function (_a) {
    var description = _a.description, onClose = _a.onClose;
    return (React.createElement(BaseToast, { variant: "info", icon: pro_regular_svg_icons_1.faCircleInfo, iconColor: "#17191C", description: description, onClose: onClose }));
};
exports.InfoToast = InfoToast;
/**
 * We can't simply create a useToast wrapper hook because React context won't be correctly shared when this library is
 * installed somewhere else. So instead, we use a higher order function (HOC) so chakra's useToast hook can be
 * referenced directly from the source repo.
 */
function createUseToast(useToastFromChakra) {
    return function (options) {
        if (options === void 0) { options = {}; }
        return useToastFromChakra(__assign(__assign({}, options), { render: function (_a) {
                var status = _a.status, description = _a.description, onClose = _a.onClose;
                if (status === 'success') {
                    return React.createElement(exports.SuccessToast, { description: description, onClose: onClose });
                }
                if (status === 'error') {
                    return React.createElement(exports.ErrorToast, { description: description, onClose: onClose });
                }
                if (status === 'info') {
                    return React.createElement(exports.InfoToast, { description: description, onClose: onClose });
                }
                return null;
            } }));
    };
}
exports.createUseToast = createUseToast;
